/* @flow */
import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import FormGroup from '@material-ui/core/FormGroup';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';

import styles from './ElectroToggledRadioGroup.module.scss';

/**
 * ElectroToggledRadioGroup
 *
 * @prop   {Object}   field
 * @prop   {String}   secondaryKey
 * @prop   {Boolean}  inline
 * @prop   {Boolean}  disabled
 * @prop   {Boolean}  isBoolean
 * @prop   {String}   inputLabel
 * @return {React.Node}
 */

type TypeProps = {
  field: Object,
  secondaryKey?: string,
  isBoolean?: boolean,
  disabled?: boolean,
  inline?: boolean,
};

@translate()
@observer
class ElectroToggledRadioGroup extends React.Component<*> {
  props: TypeProps;

  static defaultProps = {
    disabled: false,
    isBoolean: false,
  };

  @observable localState = {
    userType: 'customer',
  };

  @action.bound
  toggleUserType = (evt: SyntheticInputEvent<*>) => {
    this.localState.userType = evt.target.value;
  };

  @action.bound
  setUserType = (userType: string) => {
    this.localState.userType = userType.toString();
  };

  getUserTypeByRoleId = (roleId: number) => (roleId > 5 ? 'internal' : 'customer');

  componentDidMount() {
    const { field }: Object = this.props;

    if (field && field.extra) {
      this.setUserType(this.getUserTypeByRoleId(field.extra.roleId));
    }
  }

  render(): ?React.Element<*> {
    const { field, secondaryKey, inline, disabled }: TypeProps = this.props;
    const isInline: ?string = inline ? styles.inline : null;
    const roles: Array<Object> =
      field.extra && field.extra.options ? field.extra.options : field.options;

    return (
      <div className={`${styles['radio-group']} ${isInline}`}>
        <FormControl disabled={disabled}>
          <RadioGroup
            aria-label="User Type"
            name="userType"
            className={`${styles['radio-form-group']} ${styles['radio-inline']}`}
            value={this.localState.userType}
            onChange={this.toggleUserType}
          >
            <FormControlLabel value="customer" control={<Radio />} label="Customer" />
            <FormControlLabel value="internal" control={<Radio />} label="Internal" />
          </RadioGroup>
          <FormGroup className={styles['radio-form-group']}>
            {roles.map(role => {
              // TODO: This needs to be refactored such that we do not rely on internal/external users order
              if (role.value > 5) {
                return this.localState.userType === 'internal' ? (
                  <FormGroup key={role.value}>
                    <FormControlLabel
                      value={role.value.toString()}
                      label={role.label}
                      control={<Radio checked={role.value == field.value} />}
                      onChange={(evt: SyntheticInputEvent<*>) => {
                        field.set(evt.target.value);
                      }}
                    />
                    {secondaryKey && role[secondaryKey] && <p>{role[secondaryKey]}</p>}
                  </FormGroup>
                ) : null;
              } else {
                return this.localState.userType === 'customer' ? (
                  <FormGroup key={role.value}>
                    <FormControlLabel
                      value={role.value.toString()}
                      label={role.label}
                      control={<Radio checked={role.value == field.value} />}
                      onChange={(evt: SyntheticInputEvent<*>) => {
                        field.set(evt.target.value);
                      }}
                    />
                    {secondaryKey && role[secondaryKey] && <p>{role[secondaryKey]}</p>}
                  </FormGroup>
                ) : null;
              }
            })}
          </FormGroup>
          {field.showError && field.error && (
            <FormHelperText error={true}>{field.error}</FormHelperText>
          )}
        </FormControl>
      </div>
    );
  }
}

export default ElectroToggledRadioGroup;
